import useDataStore from "../store/dataStore.ts";

export const getEventByReference = (eventReference: string | undefined) => {
  const currentEvents = useDataStore.getState().currentEvents;

  // Trouver l'événement correspondant à la référence
  const eventItem = currentEvents?.find(
    (item: any) => item?.event?.reference === eventReference
  );
  // Retourner les services associés ou un tableau vide si aucun événement n'est trouvé
  return eventItem;
};

export const getServicesByReference = (
  services: [],
  serviceReference: string | undefined
) => {
  const filteredServices = services?.filter(
    (service: any) => service?.reference === serviceReference
  );
  return filteredServices[0] ;
};

export const getEventAndTicket = (events: any[], eventReference: string | undefined)=> {
  return events?.find(item=> item?.event?.reference === eventReference)
}

export const getPurchasedTicketsByEventsRef = (eventReference: string | undefined) => {
  const myTickets = useDataStore.getState().myTickets;
  // @ts-ignore
  return myTickets?.find(item=> item?.event?.reference === eventReference)
}

export const getMyFilteredTickets = (tickets: any) => {
  const filteredTickets = tickets?.sort((a: { createdAt: string | number | Date; state: number; }, b: { createdAt: string | number | Date; state: number; }) => {
    // Trier par date (plus récent en premier)
    // @ts-ignore
    const dateDiff = new Date(b.createdAt) - new Date(a.createdAt);
    if (dateDiff !== 0) return dateDiff;

    // @ts-ignore
    if ((a.state === 1 || a.state === 7 ) && (b.state !== 1 || b.state !== 7)) return -1;
    // @ts-ignore
    if ((b.state === 1 || b.state === 7 ) && (a.state !== 1 || a.state !== 7)) return 1;

    return 0;
  });

  //const finalTickets =
  return filteredTickets;
}
